// extracted by mini-css-extract-plugin
export default {"rowHeader":"DelaysCharges_rowHeader__GSZ-P","columnHeader":"DelaysCharges_columnHeader__q-KK5"};